import {
  LocalePortableText,
  LocalePortableTextType,
} from 'groq/shared/LocalePortableText';
import { LocaleSeo, LocaleSeoType } from 'groq/shared/LocaleSeo';
import { LocaleString, LocaleStringType } from 'groq/shared/LocaleString';

export type SupportPageContent = {
  _id: string;
  _type: string;
  title: string;
  localeTitle?: LocaleStringType;
  onlineFrom?: string;
  onlineTo?: string;
  availableFrom?: string;
  availableTo?: string;
  generateSidebarNavigation?: boolean;
  integration?: string;
  content?: LocalePortableTextType;
  localeContent?: LocalePortableTextType;
  sidebarContent?: LocalePortableTextType;
  seo?: LocaleSeoType;
};

export type SupportPagesContent = {
  _id: string;
  title: string;
  localeTitle?: LocaleStringType;
  url: string;
}[];

declare module 'groq/GroqOperationNames' {
  interface GroqOperationNames {
    SupportPage: SupportPageContent;
  }
}

declare module 'groq/GroqOperationNames' {
  interface GroqOperationNames {
    SupportPages: SupportPagesContent;
  }
}

// NOTE: Temporaily using pulling in aviailableFrom/availableTo Twice to support existing sidebar setup
// Needs additional Investigation
export const SupportPageQuery = `
*[_type == "SupportPage" && url.current == $supportUrl && country == $country][0] {
  _id,
  _type,
  title,
  ${LocaleString('localeTitle')},
  "onlineFrom": availableFrom,
  "onlineTo": availableTo,
  availableFrom,
  availableTo,
  ${LocalePortableText('content')},
  ${LocalePortableText('localeContent')},
  ${LocalePortableText('sidebarContent')},
  generateSidebarNavigation,
  ${LocaleSeo('seo')},
}`;

export const SupportPagesQuery = `
*[_type == "SupportPage"][country == $country
  && (
    !defined(availableOn)
    || availableOn == "all"
    || availableOn == $platform
    || $platform == ""
  )
] {
  _id,
  _type,
  title,
  ${LocaleString('localeTitle')},
  "url": url.current,
  availableFrom,
  availableTo,
}
`;
